'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/simulator'));
    processInclude(require('./product/snsShare'));
    processInclude(require('./product/salesCounter'));
    processInclude(require('./account/waitlist'));
});
